// A JSON rendering that does not depend on key order. Firestore hands map
// fields back in no fixed order from one snapshot to the next, so two reads of
// the same document can differ under JSON.stringify while holding the same
// data. Comparing the two renderings from here answers "has this changed?".

const isPlainObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value);

export function stableStringify(value) {
  if (Array.isArray(value)) {
    return `[${value.map(stableStringify).join(',')}]`;
  }
  if (isPlainObject(value)) {
    const entries = Object.keys(value)
      .sort()
      .map((key) => `${JSON.stringify(key)}:${stableStringify(value[key])}`);
    return `{${entries.join(',')}}`;
  }
  return JSON.stringify(value === undefined ? null : value);
}
